import React from 'react'
import { formatDate } from "../../../utils/convertDate";
import { FormatMoney } from "../../../utils/formatMoney";

const Reports = ({reports}) => {
  return (
    <div className="mt-12 mb-10 flex flex-col">
    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
          <table className="min-w-full table-fixed divide-y divide-gray-300">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left  text-gray-800"
                >
                  Bureau Name
                </th>
                <th
                  scope="col"
                  className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800 "
                >
                  Debit Account Number
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  IsClean
                </th>
                <th
                  scope="col"
                  className="min-w-[8rem] px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Block Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Date Blocked
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Date Unblocked
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Bureau Hierarchy
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Debit Attempted
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Date Debitted
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Debit Reference
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Transfer Reference
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Transfer Status
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Block Refernce
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Unblock Reference
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Modified By
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  Date Modified
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                ></th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left italic font-normal text-gray-800"
                >
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {reports?.map((person) => (
                <tr className="bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.bureauName}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.debitAccountNumber}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.isClean === true
                      ? "Clean"
                      : "Not clean"}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.blockStatus}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {formatDate(person?.dateBlocked)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {formatDate(person?.dateUnBlocked)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.bureauHierarchy}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.debitAttempted}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {formatDate(person?.dateDebited)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.debitReference}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.transferReference}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.transferStatus}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.blockReference}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.unBlockReference}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {person?.modifiedBy}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-gray-900">
                    {formatDate(person?.dateModified)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Reports
